<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Text Area Widget
      </h3>

      <div :class="'section_wrap '+(settings === 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings === 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget name"
              placeholder="Enter a name for the widget (optional)"
              width="full"
            />

            <div 
              class="content-block"
              :class="{'with-placeholders': report.is_template}"
            >
              <ContentPlaceholders
                v-if="report.is_template"
                title="AUTO-FILL TAGS"
                :placeholders="placeholders"
              />
              <custom-textarea
                v-model="widget.text"
                :font="report.font"
                label="Text"
                width="full"
              />
            </div>
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import _ from 'lodash';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomTextarea from '../../global/forms/CustomWysiwyg.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';
import ContentPlaceholders from "../../../../../js/components/global/assets/ContentPlaceholders.vue";

export default {
  components: {
    CustomInput,
    CustomTextarea,
    AccordionTransition,
    ContentPlaceholders,
  },
  emits: ['refresh-widget'],
  data() {
    return {
      settings: 'widget',
      widget: {
        id: `widget-textarea-${Date.now()}`,
        name: 'Text Area Widget',
        type: 'textarea',
        w: 12,
        h: 25,
        attributes: {},
        text: '',
        content: ''
      },
      requiredFields: [],
      placeholders: {
        WEBSITE_URL: 'Website URL',
        SIMPLE_URL: 'Simple URL',
      },
    }
  },
  computed: {
    ...mapState(['widgetModal']),
    ...mapState('report', ['report'])
  },
  beforeMount() {
    if (this.widgetModal.widget) {
      _.merge(this.widget, this.widgetModal.widget);
      // This will update any older widgets to use the new div wrapper
      if (!this.widget.text) {
        this.widget.text = this.widgetModal.widget.content
      }
    }
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    async save() {
      this.widget.content = `<div class="widget_textarea">${this.widget.text}</div>`;

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }
      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    }
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
  .content-block {
    width: 100%;
    &.with-placeholders {
      .placeholders {
        margin-bottom: 1rem;
      }

      @media (min-width: 768px) {
        display: flex;
        gap: 1rem;
        .custom_input {
          order: 1;
          width: 80%;
        }
        .placeholders {
          order: 2;
          width: 20%;
          padding-top: 0.9rem !important;
        }
      }
    }
  }
</style>
